import PropTypes from 'prop-types';
import { useState } from 'react';
import ContactTagList from 'apps/contact/components/contact-tag-list';
import ModalConfirm from 'components/modals/modal-confirm';

const ContactPicker = ({ header, onSelect, description, requestHide, singleSelect }) => {
  const [selectedContacts, setSelectedContacts] = useState([]);

  const handleSubmit = () => {
    onSelect(selectedContacts);
    requestHide();
  };

  const handleContactSelect = (selected) => {
    setSelectedContacts(singleSelect ? selected.slice(-1) : selected);
  };

  return (
    <ModalConfirm
      className="contact-picker"
      header={header || 'Select Constituents'}
      buttonLabel="Select"
      hasMargin
      disableButton={!selectedContacts || !selectedContacts?.length}
      onSubmit={handleSubmit}
      onCancel={requestHide}
    >
      <div>{description}</div>

      <div className="contact-picker--input clearfix">
        <ContactTagList selected={selectedContacts} onSelect={handleContactSelect} />
      </div>
    </ModalConfirm>
  );
};

ContactPicker.propTypes = {
  header: PropTypes.string,
  onSelect: PropTypes.func.isRequired,
  description: PropTypes.node,
  requestHide: PropTypes.func.isRequired,
  singleSelect: PropTypes.bool,
};

export default ContactPicker;
